import { useTranslation } from 'providers/GILT.provider';

import { TooltipMetricTexts } from './TooltipMetricTexts.component';

import CN from './TooltipMetricTextForecast.module.scss';

const ClientBoughtRetailPct = ({ t }) => <div className={CN.component}>{t('composite.tooltipKpisMetricsPast.clientsBoughtRetailPct.description')}</div>;

const RebookingRatePct = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsPast.rebookingRatePct.description')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.rebookingRatePct.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.rebookingRatePct.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.rebookingRatePct.rule3')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.rebookingRatePct.rule4')}</span>
  </div>
);

const RebookingRateNewClientsPct = ({ t }) => <div className={CN.component}>{t('composite.tooltipKpisMetricsPast.rebookingRateNewClientsPct.description')}</div>;

const RebookingRateExistingClientsPct = ({ t }) => <div className={CN.component}>{t('composite.tooltipKpisMetricsPast.rebookingRateExistingClientsPct.description')}</div>;

const TotalRevenue = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsPast.totalRevenue.description')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.totalRevenue.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.totalRevenue.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.totalRevenue.rule3')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.totalRevenue.rule4')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.totalRevenue.rule5')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.totalRevenue.rule6')}</span>
    <span>{t('composite.tooltipKpisMetricsPast.totalRevenue.excludes')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.totalRevenue.tips')}</span>
  </div>
);

const RevenueExclRetail = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsPast.revenueExclRetail.description')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.revenueExclRetail.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.revenueExclRetail.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.revenueExclRetail.rule3')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.revenueExclRetail.rule4')}</span>
  </div>
);

const RetailRevenue = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsPast.retailRevenue.description')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.retailRevenue.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.retailRevenue.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.retailRevenue.rule3')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.retailRevenue.rule4')}</span>
  </div>
);

const AvgBillValue = ({ t }) => <div className={CN.component}>{t('composite.tooltipKpisMetricsPast.avgBillValue.description')}</div>;

const RevenuePerCategory = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsPast.revenuePerCategory.description')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.revenuePerCategory.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.revenuePerCategory.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.revenuePerCategory.rule3')}</span>
  </div>
);

const ClientsRebookedCount = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsPast.clientsRebookedCount.description')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.clientsRebookedCount.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.clientsRebookedCount.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.clientsRebookedCount.rule3')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.clientsRebookedCount.rule4')}</span>
  </div>
);

const NewClientsRebookedCount = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsPast.newClientsRebookedCount.description')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.newClientsRebookedCount.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.newClientsRebookedCount.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.newClientsRebookedCount.rule3')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.newClientsRebookedCount.rule4')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsPast.newClientsRebookedCount.rule5')}</span>
  </div>
);

// Main component
const TooltipMetricTextPast = ({ metric }) => {
  const { t } = useTranslation();

  switch (metric) {
    case 'clients_bought_retail_pct':
      return <ClientBoughtRetailPct t={t} />;
    case 'rebooking_rate_pct':
      return <RebookingRatePct t={t} />;
    case 'rebooking_rate_new_clients_pct':
      return <RebookingRateNewClientsPct t={t} />;
    case 'rebooking_rate_existing_clients_pct':
      return <RebookingRateExistingClientsPct t={t} />;
    case 'total_revenue':
      return <TotalRevenue t={t} />;
    case 'revenue_excl_retail':
      return <RevenueExclRetail t={t} />;
    case 'retail_revenue':
      return <RetailRevenue t={t} />;
    case 'avg_bill_value':
      return <AvgBillValue t={t} />;
    case 'revenue_per_category':
      return <RevenuePerCategory t={t} />;
    case 'clients_rebooked_count':
      return <ClientsRebookedCount t={t} />;
    case 'new_clients_rebooked_count':
      return <NewClientsRebookedCount t={t} />;
    default:
      return <TooltipMetricTexts metric={metric} />;
  }
};

export default TooltipMetricTextPast;
